import { render, staticRenderFns } from "./csiApp.vue?vue&type=template&id=5265283a&scoped=true&"
var script = {}
import style0 from "./csiApp.vue?vue&type=style&index=0&id=5265283a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265283a",
  null
  
)

export default component.exports